var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"leading-9 text-white3 text-sm flex items-center justify-between"},[_c('div',{staticClass:"flex-shrink-0 mr-3"},[_vm._t("default")],2),_c('div',{staticClass:"flex-grow-0 hide"},[_vm._t("right")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }